import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logoSignUp.png";
import {
  resetPasswordWithOtp,
  sendPasswordResetOtp,
} from "../services/authApi";
import "./SignIn.scss";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const runRequest = async (request) => {
    setLoading(true);
    setError("");
    setMessage("");

    try {
      await request();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = (event) => {
    event.preventDefault();
    const normalizedEmail = email.trim().toLowerCase();

    if (!normalizedEmail) {
      setError("Please enter your email address.");
      return;
    }

    runRequest(async () => {
      const response = await sendPasswordResetOtp(normalizedEmail);
      setEmail(normalizedEmail);
      setMessage(response.message);
      setStep("reset");
    });
  };

  const handleResetPassword = (event) => {
    event.preventDefault();

    if (!/^\d{6}$/.test(otp)) {
      setError("Please enter the 6-digit OTP.");
      return;
    }

    if (newPassword.length < 8) {
      setError("Your new password must be at least 8 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("The passwords do not match.");
      return;
    }

    runRequest(async () => {
      await resetPasswordWithOtp({ email, otp, newPassword });
      navigate("/signin", {
        replace: true,
        state: { passwordReset: true },
      });
    });
  };

  return (
    <div className="signIn-container">
      <div className="col centerAlign authPageContent">
        <img src={logo} alt="Vetta" />
        <form
          className="col loginForm passwordResetForm"
          onSubmit={step === "email" ? handleSendOtp : handleResetPassword}
        >
          <div className="h1">Reset your password</div>
          <p className="b3 midGray">
            {step === "email"
              ? "Enter your account email and we’ll send you a one-time code."
              : `Enter the code sent to ${email} and choose a new password.`}
          </p>

          {step === "email" ? (
            <input
              type="email"
              name="email"
              value={email}
              placeholder="Email"
              autoComplete="email"
              onChange={(event) => setEmail(event.target.value)}
            />
          ) : (
            <>
              <input
                type="text"
                name="otp"
                value={otp}
                placeholder="6-digit OTP"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength="6"
                onChange={(event) =>
                  setOtp(event.target.value.replace(/\D/g, "").slice(0, 6))
                }
              />
              <input
                type="password"
                name="newPassword"
                value={newPassword}
                placeholder="New password"
                autoComplete="new-password"
                onChange={(event) => setNewPassword(event.target.value)}
              />
              <input
                type="password"
                name="confirmPassword"
                value={confirmPassword}
                placeholder="Confirm new password"
                autoComplete="new-password"
                onChange={(event) => setConfirmPassword(event.target.value)}
              />
            </>
          )}

          {error && <div className="b3 error authMessage">{error}</div>}
          {message && <div className="b3 authSuccess authMessage">{message}</div>}

          <button className="button1 h3 authSubmitButton" disabled={loading}>
            {loading
              ? "Please wait..."
              : step === "email"
              ? "Send OTP"
              : "Change password"}
          </button>

          {step === "reset" && (
            <button
              type="button"
              className="authTextButton b4"
              disabled={loading}
              onClick={handleSendOtp}
            >
              Resend OTP
            </button>
          )}

          <Link to="/signin" className="b4 hippiBlue textCenter">
            Back to login
          </Link>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
